export default {
  methods: {
    dateInRanges(date) {
      date=((date || "")+"").substring(0, 10);
      if (appRoot.loggedIn && appRoot.loggedIn.allPayments) {
        for(var payment of appRoot.loggedIn.allPayments) {
//           console.log(date, payment.rangeStartDate, payment.rangeEndDate);
          var afterStart=!payment.rangeStartDate || (payment.rangeStartDate<=date);
          var beforeEnd=!payment.rangeEndDate || (payment.rangeEndDate>=date);
          if (afterStart && beforeEnd)
            return true;
        }
        return false;
      } else
        return true;
    },
  },
  
}
